export const containsRowWithErrors = (rows) =>
  rows?.find((row) =>
    row.content?.find(
      (cell) => cell?.props.error !== "" && cell?.props.error !== undefined
    )
  ) !== undefined;

/*
 * Compares two arrays of objects to determine if ignoreListWordsEdited requires updating
 *
 * @returns {boolean} - Returns true if a category has been expanded or collapsed,
 * returns true if list has been reordered using drag and drop and enables save button
 * @param arr1
 * @param arr2
 */
export const rowsListReordered = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0; i < arr1.length; i++) {
    const row1 = arr1[i];
    const row2 = arr2[i];

    if (row1.id !== row2.id) {
      return true; // List has been reordered, set table to edited (enable save button)
    }
  }
  return false; // No differences found
};

export const setListOnUpdate = (rows, getRows, ignoreList, setNewList) => {
  const updatedElement = rows?.find((row) =>
    row.content?.find((cell) => cell?.props.isSelected)
  );
  if (rows.length > 1 && updatedElement !== undefined) {
    setNewList();
  } else if (
    updatedElement === undefined &&
    rowsListReordered(rows, getRows(ignoreList))
  ) {
    setNewList();
  }
};
